import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userEmail: "",
  newRegistration: false,
};

export const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    setCommunityUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setCommunityNewRegistration: (state, action) => {
      state.newRegistration = action.payload;
    },
  },
});

export const { setCommunityUserEmail, setCommunityNewRegistration } =
  communitySlice.actions;

export default communitySlice.reducer;
